"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRequest = void 0;
const buildRequest = (entryKey, caller) => {
    return async () => {
        return caller()
            .then(({ data }) => ({ entryKey, data }))
            .catch((e) => ({ entryKey, error: e }));
    };
};
exports.buildRequest = buildRequest;
//# sourceMappingURL=buildRequest.js.map